class ReferrerHandler extends HTMLElement {
  constructor() {
    super();
    this.isExternal = false;
    this.isSearch = false;
  }

  connectedCallback() {
    this.checkReferrer();
    this.checkSearchParam();
  }

  checkReferrer() {
    const referrer = document.referrer;
    if (!referrer || !referrer.includes(window.location.hostname)) {
      this.isExternal = true;
      console.log("L'utente è atterrato direttamente (sito esterno o campagna).");
    } else {
      console.log("L'utente è arrivato da una navigazione interna al sito.");
    }
  }

  checkSearchParam() {
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has('search_provided')) {
      this.isSearch = true;
      console.log("Provenienza: Ricerca nel sito (search_provided=true).");
    }
  }
}

customElements.define('referrer-handler', ReferrerHandler);